import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Panel } from "primereact/panel";
import findServico from "../../service/findServico";
import { SortOrder } from "primereact/api";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Messages } from "primereact/messages";
import getOpcoesConsultaAgrupada from "../../service/getOpcoesConsultaAgrupada";


export default function PlanoCadastrar({plano, onClose, onSave}:{plano:any, onClose: () => void, onSave: (plano:any) => void}) {
  const { t } = useTranslation();
  const [showPlanoServico, setShowPlanoServico] = useState<boolean>(false);
  const [showPlanoServicoValor, setShowPlanoServicoValor] = useState<boolean>(false);
  const sortByDescricao = (list: any[]) =>
    [...(list ?? [])].sort((a, b) => {
      const da = a.servico?.descricao ?? '';
      const db = b.servico?.descricao ?? '';
      return da.localeCompare(db, 'pt-BR');
    });
  const [planosServico, setPlanosServico] = useState<any[]>(sortByDescricao(plano?.planosServico));
  const [planosServicoValor, setPlanosServicoValor] = useState<any[]>();
  const [valor, setValor] = useState<number|null|undefined>(null);
  const [data, setData] = useState<Date|null|undefined>(null);
  const [servicos, setServicos] = useState<any>([]);
  const [selectedServico, setSelectedServico] = useState<any>();
  const [selectedOpcaoAgrupada, setSelectedOpcaoAgrupada] = useState<any>();
  const msgs = useRef<Messages>(null);
  const [planoServicoValorEdit, setPlanoServicoValorEdit] = useState<any>();
  const [planoServicoEdit, setPlanoServicoEdit] = useState<any>();
  const [opcoesAgrupada, setOpcoesAgrupada] = useState<any>([]);
  const [opcoesCarregadas, setOpcoesCarregadas] = useState<boolean>(false);
  const [sortField, setSortField] = useState<string>('servico.descricao');
  const [sortOrder, setSortOrder] = useState<SortOrder>(1);
  const snapshotOriginal = useRef<Map<string, {valores: Map<string, {data: number, valor: number}>, total: number}>>();
  if(!snapshotOriginal.current){
    const mapa = new Map<string, {valores: Map<string, {data: number, valor: number}>, total: number}>();
    (plano?.planosServico ?? []).forEach((ps:any) => {
      if(ps.id){
        const valores = new Map<string, {data: number, valor: number}>();
        (ps.planosServicoValor ?? []).forEach((v:any) => { if(v.id){ valores.set(v.id, {data: new Date(v.data).getTime(), valor: Number(v.valor)}) } });
        mapa.set(ps.id, {valores, total: (ps.planosServicoValor ?? []).length});
      }
    });
    snapshotOriginal.current = mapa;
  }

  const defaultValues = {
    descricao: '',
    vcm: null as number | null
  };
  defaultValues.descricao = plano.descricao ? plano.descricao.toString() : ''
  defaultValues.vcm = plano.vcm !== null && plano.vcm !== undefined && plano.vcm !== '' ? Number(plano.vcm) : null
 
  useEffect(()=>{
    const lazyServico = {
      first: 0,
      rows: 99999999,
      page: 1,
      descricao: null,
      tipoBulhete: null,
      sortField: 'descricao',
      sortOrder: SortOrder.DESC
    };
    const opcoesPromise = getOpcoesConsultaAgrupada().then((data) => setOpcoesAgrupada(data))
    const servicosPromise = findServico(lazyServico).then((data) => setServicos(data.servicos))
    Promise.all([opcoesPromise, servicosPromise]).catch(() => undefined).finally(() => setOpcoesCarregadas(true))
  }, [])

  useEffect(()=>{
    if(showPlanoServico){
      requestAnimationFrame(() => window.scrollTo({top: document.documentElement.scrollHeight, behavior: 'smooth'}))
    }
  }, [showPlanoServico])
  
  const {
      control,
      formState: { errors},
      handleSubmit
  } = useForm({ defaultValues });

  const onSubmit = (data:any) => {
      data.descricao  && save(data);
  };

const getLabelIdentificador = (identificador:string) => {
  const opcao = opcoesAgrupada?.find((s1:any)=> s1.value === identificador)
  return opcao?.label ? opcao.label.split(":")[0] : ''
}

const salvarServico = () => {
  if(selectedServico && (selectedServico.tipoBilhete !== 'AGRUPADOR' || selectedOpcaoAgrupada) && planosServicoValor && planosServicoValor.length > 0){
    const lista: any[] = []
    planosServico?.forEach((p) => lista.push(p))
    const results = planosServico?.filter((p) => p.servico.tipoBilhete === selectedServico.tipoBilhete && (selectedServico.tipoBilhete !== 'AGRUPADOR' || p.identificador === selectedOpcaoAgrupada))
    if(results && results.length !== 0 && (!planoServicoEdit || planoServicoEdit.servico.tipoBilhete !== selectedServico.tipoBilhete)){
      msgs.current?.clear();
      msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Serviço já existe', closable: false }
         
      ]);
      window.scrollTo(0, 0);
    }
    else{
      if(!planoServicoEdit){
        lista.push({servico:selectedServico, identificador: (selectedOpcaoAgrupada ?  selectedOpcaoAgrupada : null), planosServicoValor:planosServicoValor})
      }
      else{
        const indice = lista.indexOf(planoServicoEdit)
        const atualizado = {...planoServicoEdit, planosServicoValor: planosServicoValor, servico: selectedServico, identificador: selectedOpcaoAgrupada ? selectedOpcaoAgrupada : null}
        if(indice === -1){ lista.push(atualizado) } else { lista[indice] = atualizado }
      }
      setPlanoServicoEdit(null)
      setPlanosServico(sortByDescricao(lista))
      setSelectedServico(null)
      setSelectedOpcaoAgrupada(null)
      setPlanosServicoValor([])
      setShowPlanoServico(false)
    }
  }
  else{
    msgs.current?.clear();
      msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Serviço e valores obrigatórios', closable: false }
         
      ]);
      window.scrollTo(0, 0);
  }
}
 
 const salvarValor = () => {
  if(data && valor){
    const lista = []
    planosServicoValor?.forEach((p) => lista.push(p))
    const results = planosServicoValor?.filter((p) => formatDate(p.data) === formatDate(data))
    if(results && results.length !== 0 && (!planoServicoValorEdit || formatDate(planoServicoValorEdit.data) !== formatDate(data))){
      msgs.current?.clear();
      msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Data já existe', closable: false }
         
      ]);
      window.scrollTo(0, 0);
    }
    else{
      if(!planoServicoValorEdit){
        lista.push({data:data, valor:valor})
      }
      else{
        planoServicoValorEdit.valor = valor;
        planoServicoValorEdit.data = data;
        
      }
      setPlanoServicoValorEdit(null)
      aplicarValores(lista)
      setData(null)
      setValor(null)
      setShowPlanoServicoValor(false)
    }
    
  }
  else{
    if (msgs.current) {
      msgs.current?.clear();
      msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Data e valor são obrigatórios', closable: false }
         
      ]);
      window.scrollTo(0, 0);
    }
  }
  
 }
 const aplicarValores = (lista:any[]) => {
  setPlanosServicoValor(lista)
  if(planoServicoEdit){
    const atualizado = {...planoServicoEdit, planosServicoValor: lista}
    setPlanoServicoEdit(atualizado)
    setPlanosServico((atual) => sortByDescricao((atual ?? []).map((p) => p === planoServicoEdit ? atualizado : p)))
  }
 }

 const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
  return value.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
  });
};

const bodyValor = (item:any) => {
  return item.planosServicoValor[item.planosServicoValor.length - 1].valor
}

const planoServicoAlterado = (item:any) => {
  const original = item.id ? snapshotOriginal.current?.get(item.id) : undefined
  if(!original){ return true }
  const valores = item.planosServicoValor ?? []
  if(valores.length !== original.total){ return true }
  return valores.some((v:any) => {
    const valorOriginal = v.id ? original.valores.get(v.id) : undefined
    return !valorOriginal || valorOriginal.data !== new Date(v.data).getTime() || valorOriginal.valor !== Number(v.valor)
  })
}

const bodyServico = (item:any) => {
  const descricao = item.servico.tipoBilhete === 'AGRUPADOR' ? getLabelIdentificador(item.identificador) : item.servico.descricao
  return <span style={{display:'inline-flex', alignItems:'center', gap:'0.5rem'}}>
          {descricao}
          {planoServicoAlterado(item) && (
            <span title="Alterações neste serviço ainda não foram salvas" style={{fontSize:'0.68rem', fontWeight:600, letterSpacing:'0.02em', color:'#8a5a00', background:'#fff6e0', border:'1px solid #f0d79b', borderRadius:'999px', padding:'0.05rem 0.5rem', whiteSpace:'nowrap'}}>não salvo</span>
          )}
        </span>
}

const dataValorAtual = (item:any) => {
  return item.planosServicoValor[item.planosServicoValor.length - 1].data
}

const bodyData = (item:any) => {
  return formatDate(dataValorAtual(item))
}

 const dateBodyTemplate = (rowData: { data: any; }) => {
  return formatDate(rowData.data);
  };
 
  const save = (data:any) => {
    const plan = {
      id: plano.id? plano.id : undefined,
      descricao:data.descricao,
      vcm: data.vcm !== null && data.vcm !== undefined ? data.vcm : null,
      planosServico: planosServico
    }
    window.scrollTo(0, 0);
    onSave(plan);
  }

  const editValorBodyTemplate = (item:any) => {
    return <>
            <Button icon="pi pi-pencil" type="button" onClick={() => {setData(item.data); setValor(item.valor);setPlanoServicoValorEdit(item);setShowPlanoServicoValor(true)}} style={{background:'transparent', color:'gray', border: 'none'}} />
            <Button icon="pi pi-trash" type="button" onClick={() => {aplicarValores(planosServicoValor?.filter((v) => formatDate(v.data) !== formatDate(item.data)) ?? [])}} style={{background:'transparent', color:'gray', border: 'none'}} />
          </>
  };

  const editServicoBodyTemplate = (item:any) => {
    return <>
      <Button icon="pi pi-pencil" type="button" onClick={(e) => {setSelectedOpcaoAgrupada(item.identificador); setSelectedServico(servicos.find((s: any) => s.descricao === item.servico.descricao) ?? item.servico); setPlanosServicoValor(item.planosServicoValor);setPlanoServicoEdit(item);setShowPlanoServico(true);}} style={{background:'transparent', color:'gray', border: 'none'}} />
      <Button icon="pi pi-trash" type="button" onClick={() => {setPlanosServico(planosServico?.filter((s) => ((item.servico.tipoBilhete === 'AGRUPADOR' && (!s.identificador || item.identificador !== s.identificador)) || (item.servico.tipoBilhete !== 'AGRUPADOR' && s.servico.tipoBilhete !== item.servico.tipoBilhete))))}} style={{background:'transparent', color:'gray', border: 'none'}} />
    </>
  };
  
  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  const footerTableValor = (
    <React.Fragment>
      {!showPlanoServicoValor && (
          <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Adicionar Valor" onClick={()=>setShowPlanoServicoValor(true)} />
          </div>
      )}
      {showPlanoServicoValor && (
            <Panel>
              <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <label htmlFor="dataFinal" className="font-bold block mb-2 required">{t('data')} </label>
                  <Calendar id='dataFinal' value={data} onChange={(e) => setData(e.value)} showIcon dateFormat="dd/mm/yy" locale='pt'/>
                </div>
                <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="servico" className="font-bold block mb-2 required">{t('valor')} </label>
                    <InputNumber inputId="currency" value={valor} onValueChange={(e) => setValor(e.value)} mode="currency" currency="BRL" locale="pt-BR" />
                  </div>
              </div>
               <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
                <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar Valor" onClick={() => salvarValor()}  />
                <Button label="Fechar" icon="pi pi-times" style={{color:'#183462'}} onClick={() => setShowPlanoServicoValor(false)} className="p-button-text" />
              </div>
            </Panel>
      )}
    </React.Fragment>
  );

  const paginatorRight = (
    <React.Fragment>
        {!showPlanoServico && (
          <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Adicionar Serviço" onClick={()=>setShowPlanoServico(true)} />
          </div>
          )
        }
          {showPlanoServico && (
            <Panel>
               
                <div className="grid">
                  <div className="col p-fluid flex flex-wrap">
                  <label htmlFor="servico" className="font-bold block mb-2 required">{t('servico')} </label>
                    <Dropdown style={{width: '50%'}} value={selectedServico} onChange={(e) => setSelectedServico(e.value)} options={servicos} optionLabel="descricao" dataKey="descricao" placeholder="Selecione Serviço" 
                        filter className=" md:w-14rem" />  
                  </div>
                  {selectedServico && selectedServico.tipoBilhete === 'AGRUPADOR' && (
                    <div className="col p-fluid flex flex-wrap">
                      <label htmlFor="opcao" className="font-bold block mb-2 required">{t('opcao')} </label>
                      <Dropdown style={{width: '50%'}} value={selectedOpcaoAgrupada} onChange={(e) => setSelectedOpcaoAgrupada(e.value)} options={opcoesAgrupada} optionLabel="label" optionValue="value" placeholder="Selecione Opção" 
                          filter className=" md:w-14rem" />  
                    </div>
                  )}
                  
                </div>
                <br></br>
                <DataTable size="small" footer={footerTableValor} value={planosServicoValor} tableStyle={{ minWidth: '50rem' }}>
                  <Column  body={dateBodyTemplate} dataType="Date" header={t('data')}></Column>
                  <Column field="valor" header={t('valor')}></Column>
                  <Column body={editValorBodyTemplate} />
                </DataTable>
              {!showPlanoServicoValor && (
                <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
                  <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar Serviço" onClick={()=>salvarServico()} />
                  <Button label="Fechar" icon="pi pi-times" style={{color:'#183462'}} onClick={() => setShowPlanoServico(false)} className="p-button-text" />
                </div>
              )}
             
            
            </Panel>
          )}
          
    </React.Fragment>
    );

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <Messages ref={msgs} />
        <div>
          <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                
                  <Controller
                      name="descricao"
                      control={control}
                      rules={{ required: 'Descrição é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.descricao })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="descricao" className="font-bold block mb-2 required">{t('descricao')} </label>
                                <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />


              </div>
              <div className="col p-fluid flex flex-wrap">
                  <Controller
                      name="vcm"
                      control={control}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.vcm })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="vcm" className="font-bold block mb-2">{t('vcm')} </label>
                                <InputNumber id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.value)} mode="currency" currency="BRL" locale="pt-BR" />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
              </div>
          </div>
          
       
        </div>
        <br></br>
        <style>{`.plano-servico-alterado > td { background: #fffdf3; } .plano-servico-alterado > td:first-child { box-shadow: inset 3px 0 0 #e2a400; }`}</style>
        <DataTable size="small" loading={!opcoesCarregadas} paginatorRight={paginatorRight} footer={paginatorRight} value={opcoesCarregadas ? planosServico : undefined} sortField={sortField} sortOrder={sortOrder} onSort={(e) => { setSortField(e.sortField); setSortOrder(e.sortOrder ?? 1); }} rowClassName={(item:any) => planoServicoAlterado(item) ? 'plano-servico-alterado' : ''} tableStyle={{ minWidth: '50rem' }}>
          <Column sortable sortFunction={(e) => { const getLabel = (item: any) => item.servico.tipoBilhete === 'AGRUPADOR' ? getLabelIdentificador(item.identificador) : item.servico.descricao; return [...e.data].sort((a, b) => getLabel(a).localeCompare(getLabel(b), 'pt-BR') * (e.order ?? 1)); }} field="servico.descricao" body={bodyServico} header={t('servico')}></Column>
          <Column sortable field="data" sortFunction={(e) => [...e.data].sort((a, b) => (new Date(dataValorAtual(a)).getTime() - new Date(dataValorAtual(b)).getTime()) * (e.order ?? 1))} body={bodyData} header={t('data')}></Column>
          <Column sortable field="valor" sortFunction={(e) => [...e.data].sort((a, b) => (bodyValor(a) - bodyValor(b)) * (e.order ?? 1))} body={bodyValor} header={t('valor')}></Column>
          <Column body={editServicoBodyTemplate} />
        </DataTable>
        <br></br>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit"   />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div> 
    </form>
    
  )
}



